var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('TitleAndSearch',{attrs:{"icon":'icon_user',"title":_vm.$t('fleet_management.persons.persons.labels.title'),"showSearch":true}}),_c('PersonsTabs')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }